export enum ContentPlacement {
    Banner = 0,
    Response = 1,
    Kicker = 2
}
